import { Button, Modal } from "antd";
import "./DeletePhotoModal.scss";

interface Props {
  open: boolean;
  onCancel: () => void;
  onDelete: () => void;
}

export function DeletePhotoModal({ open, onCancel, onDelete }: Props) {
  return (
    <Modal className="clean one delete-photo-modal" visible={open} onCancel={onCancel} width={620} centered>
      <header>
        <h2>Delete this photo?</h2>
      </header>

      <p>
        It will be removed from your listings the next time you publish. Photos you or others added directly on Google
        aren't affected.
      </p>

      <footer>
        <Button size="large" onClick={onCancel}>
          Cancel
        </Button>
        <Button size="large" className="primary" onClick={onDelete}>
          Delete
        </Button>
      </footer>
    </Modal>
  );
}
